if (!customElements.get('leasing-recommendations')) {
  class LeasingRecommendations extends HTMLElement {
    constructor() {
      super();

      this.form = document.getElementById(this.dataset.formId);
      this._recommendations = [];

      if(this.form) {
        this.form.addEventListener('change', this.update.bind(this))
      }
    }

    get recommendations() {
      return this._recommendations;
    }

    update(newRecommendations, callback) {
      if(!this.form) {
        return;
      }

      let searchQuery;

      try {
        searchQuery = newRecommendations.map(({ handle, id, quantity }) => `${handle}|${id}|${quantity}`).join(',')
        this._recommendations = newRecommendations;
      } catch {
        console.warn('Invalid variable format given to update(), the following is NOT an array of {handle, id, quantity}: ', newRecommendations)
        return;
      }

      if(!searchQuery) {
        console.warn('Invalid variable format given to update(), the following is NOT an array of {handle, id, quantity}: ', newRecommendations)
        return;
      }

      fetch(`${Shopify.routes.root}search?q=${searchQuery}&view=leasing-recommendations`).then(f => f.text()).then(html => {
        this.innerHTML = html;
        this.querySelectorAll('leasing-recommendation').forEach(d => d.setAttribute('aria-controls', this.id));
      }).finally(() => {
        if(callback) {
          callback()
        }
      })
    }
  }

  class LeasingRecommendation extends HTMLElement {
    constructor() {
      super();
      this.loader = this.querySelector('.cart-item__loader');
      this.button = this.querySelector('button');
      if(this.button) {
        this.data = this.button.closest('[data-handle]').dataset;
        this.button.addEventListener('click', this.handleClick.bind(this));

        this.quantityInput = this.querySelector('quantity-input input[type="number"]');
        if(this.quantityInput) {
          this.quantityInput.addEventListener('change', this.handleQuantityChange.bind(this));
        }

        this.removeButton = this.querySelector('.cart-item__remove');
        if(this.removeButton) {
          this.removeButton.addEventListener('click', this.handleRemove.bind(this));
        }
      }
    }

    static upsert(array, obj) {
      let quantity = obj.quantity || 1;
      obj = { ...obj, quantity: quantity };

      const i = array.findIndex(o => o.id === obj.id);
      i > -1 ? array[i] = obj : array.push(obj);
      return array;
    }

    toggleLoading(on) {
      if(on) {
        this.classList.add('pointer-events-none');
        this.loader.hidden = false;
      }
    }

    updateRecommendations(newRecommendations) {
      this.toggleLoading(true);

      this.controlledElement.update(newRecommendations, this.toggleLoading.bind(this, false));
    }

    handleQuantityChange(event) {
      const newQuantity = Number(event.target.value);
      let newRecommendations;

      if(newQuantity === 0) {
        newRecommendations = this.controlledElement.recommendations.filter(recommendation => recommendation.id !== this.data.id);
      } else {
        newRecommendations = this.controlledElement.recommendations.map(recommendation => 
          recommendation.id !== this.data.id ? recommendation : { ...recommendation, quantity: newQuantity }
        );
      }

      this.updateRecommendations(newRecommendations);
    }

    handleRemove(event) {
      if(event) {
        event.preventDefault();
      }

      const newRecommendations = this.controlledElement.recommendations.filter(recommendation => recommendation.id !== this.data.id);

      this.updateRecommendations(newRecommendations);
    }

    handleClick(event) {
      if(event) {
        event.preventDefault();
      }

      const recommendations = this.controlledElement.recommendations;
      const newRecommendations = LeasingRecommendation.upsert(recommendations, Object.assign({}, this.data))

      this.button.setAttribute('aria-disabled', true)
      this.button.classList.add('is-loading')

      this.controlledElement.update(newRecommendations, (() => {
        this.button.setAttribute('aria-disabled', false)
        this.button.classList.remove('is-loading')
      }).bind(this));
    }

    get controlledElement() {
      return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null;
    }
  }

  customElements.define('leasing-recommendation', LeasingRecommendation);
  customElements.define('leasing-recommendations', LeasingRecommendations);
}
